<template lang="pug">
v-main
  v-container(fluid)
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Edit Chart of Accounts (COA)
      v-divider
      v-card-text(v-if="loading")
        v-progress-circular(indeterminate, color="primary")
        span.ml-3 Loading...
      v-card-text(v-else)
        v-form(ref="form", v-model="valid")
          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Business Unit
            v-col(cols="10")
              v-text-field(
                :value="formData.bu && formData.bu.name",
                label="Business Unit",
                readonly,
                disabled
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") COA Code
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.code",
                label="COA Code",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Description
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.description",
                label="Description",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Account Type
                span(style="color: #d42a2a") *
            v-col(cols="10")
              v-text-field(
                v-model="formData.type",
                label="Account Type",
                :rules="[rules.required]",
                required
              )

          v-row(no-gutters)
            v-col(cols="2") 
              v-subheader(color="black") Status
            v-col(cols="10")
              v-radio-group(v-model="formData.status", row)
                v-radio(label="Active", :value="true")
                v-radio(label="Non Active", :value="false")

        v-card-actions.my-8
          v-btn.custom__padding-btn(@click="cancel") Cancel
          v-btn.custom__padding-btn(style="background-color:#006bff; color: white", @click="submit", :disabled="!valid || submitting", :loading="submitting") Save
</template>

<script>
import axios from "axios";

export default {
  name: "COAEdit",
  data() {
    return {
      valid: false,
      loading: true,
      submitting: false,
      formData: {
        bu: null,
        code: "",
        description: "",
        type: "",
        status: true,
      },
      rules: {
        required: (v) => !!v || "This field is required",
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const token = localStorage.getItem("token");
      const id = this.$route.params.id;
      
      axios
        .get(`${process.env.VUE_APP_API}/coa/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          this.formData = {
            bu: res.data.bu,
            code: res.data.code,
            description: res.data.description,
            type: res.data.account_type,
            status: res.data.status,
          };
        })
        .catch((err) => {
          this.$toasted.error("Failed to load data", { icon: "error" });
          this.$router.push({ name: "COA List" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      
      this.submitting = true;
      const token = localStorage.getItem("token");
      const id = this.$route.params.id;
      
      const payload = {
        code: this.formData.code,
        description: this.formData.description,
        account_type: this.formData.type,
        status: this.formData.status,
      };
      
      axios
        .put(`${process.env.VUE_APP_API}/coa/${id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          this.$toasted.success("Success! COA has been updated.", { icon: "check_circle" });
          this.$router.push({ name: "COA List" });
        })
        .catch((err) => {
          const errorMsg = err.response && err.response.data && err.response.data.message || "Failed to update COA";
          this.$toasted.error(errorMsg, { icon: "error" });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    cancel() {
      this.$router.push({ name: "COA List" });
    },
  },
};
</script>

<style scoped>
.custom__padding-btn {
  margin-right: 0.5rem;
}
</style>

